import { render, staticRenderFns } from "./ServicoListFiltroModalItemInputFornecedor.vue?vue&type=template&id=204888a7"
import script from "./ServicoListFiltroModalItemInputFornecedor.vue?vue&type=script&lang=js"
export * from "./ServicoListFiltroModalItemInputFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports